/** Estados do fluxo de ingresso (espelho futuro da API). */
export const GV_INGRESSO_STATUS = {
	PODE_INGRESSAR: "pode_ingressar",
	JA_TITULAR: "ja_titular",
	VAGA_CHEIA: "vaga_cheia",
	SEM_DIAS: "sem_dias",
	PROCESSANDO: "processando",
}

export const GV_INGRESSO_STATUS_LABEL = {
	[GV_INGRESSO_STATUS.PODE_INGRESSAR]: "Dias com vagas na janela",
	[GV_INGRESSO_STATUS.JA_TITULAR]: "Você já está nesta vaga",
	[GV_INGRESSO_STATUS.VAGA_CHEIA]: "Janela sem vagas",
	[GV_INGRESSO_STATUS.SEM_DIAS]: "Sem dias na janela",
	[GV_INGRESSO_STATUS.PROCESSANDO]: "Confirmando…",
}
